import React from 'react';

export default function AboutHeader() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16 text-center">
      <span className="text-xs font-bold text-[#87412A] uppercase tracking-widest block mb-2">
        Our Leadership & Vision
      </span>
      <h1 className="text-4xl md:text-5xl font-bold text-[#1E4363] font-serif mb-6 uppercase tracking-tight">
        About CMJ Global
      </h1>
      <div className="w-20 h-1 bg-[#87412A] mx-auto mb-6"></div>
      <p className="text-[#2C3539]/80 max-w-3xl mx-auto text-lg leading-relaxed">
        Founded on the principles of continual improvement, maritime excellence, and uncompromising safety, CMJ Global provides top-tier marine surveying and commercial consultancy to stakeholders across the global shipping sector.
      </p>
    </div>
  );
}